import { AxiosRequestConfig } from 'axios';

export const withAuthHeader = (token?: string, config?: AxiosRequestConfig): AxiosRequestConfig => {
  if (!token) return config || {};

  return {
    ...config,
    headers: {
      ...config?.headers,
      Authorization: token,
    },
  };
};
